export const withLeadingZero = (val: number) =>
    val < 10 ? `0${val}` : `${val}`;

export const getNumsRange = (from: number, to: number) => {
    const res = [];
    for (let i = from; i <= to; i++) {
        res.push(i);
    }
    return res;
};
